import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NewsList = () => {
    const [data, SetData] = useState([]);
    const [error, SetError] = useState(null);
    const [infotext, SetInfotext] = useState("");
    const [confirmDeleteId, SetConfirmDeleteId] = useState(null); 
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://haldor-infoapp-test.azurewebsites.net/api/Information", {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response.status === 200) {
                    const result = await response.json();
                    SetData(result);
                } else if (response.status === 404) {
                    SetError(response.status);
                    console.log('Error');
                } else {
                    SetError(response.status);
                    console.log('Error');
                }
            } catch (Error) {
                console.log("Error");
                SetError("Network connection failed");
            }
        };

        fetchData();

    }, []);

    const handleClick = (id) => {
        navigate(`/news/${id}`);
    };

    const handleUpdate = (id, event) => {
        event.stopPropagation();
        navigate(`/update/${id}`);
    };

    const handleDelete = async (id, event) => {
        event.stopPropagation();

        try {
            const response = await fetch(`https://haldor-infoapp-test.azurewebsites.net/api/Information/${id}`, {
                method: 'DELETE',
            });

            if (response.status === 200) {
                console.log("Delete method");
                SetInfotext("Was deleted successfully");
                
                SetData(prevData => prevData.filter(item => item.id !== id));
                SetConfirmDeleteId(null); 
            }
            if (response.status === 404) {
                SetInfotext("Item was not found");
            }
        } catch (Error) {
            console.log("Error", Error);
            SetError("Something went wrong");
        }
    };

    const handleDeleteConfirm = (e, id) => {
        e.stopPropagation();
        SetConfirmDeleteId(id); 
    };

    const handleCancelDelete = (e) => {
        e.stopPropagation();
        SetConfirmDeleteId(null); 
    };

    return (
        <div className="information-list">
            <div>
                <label htmlFor="dateFilter">Filter by date:</label>
                <select>
                    <option value="">Filter</option>
                    <option value="">Last Week</option>
                    <option value="">Last Month</option>
                    <option value="">Last Year</option>
                </select>
                <label htmlFor="dateFilter">Filter by creator:</label>
                <select>
                    <option value="">Filter</option>
                    <option>Today</option>
                    <option>Last Week</option>
                    <option>Last Month</option>
                    <option>Last Year</option>
                </select>
            </div>

            {infotext && <p>{infotext}</p>}
            {error && <p className="error-message">{error}</p>}

            {data.length > 0 ? (
                data.map((item) => {
                    return (
                        <div key={item.id} className="information-item" onClick={() => handleClick(item.id)}>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                            <p><strong>Författare: </strong>{item.creator}</p>

                            {item.status ? (
                                <div className="isActive">
                                    <i className="fa-solid fa-circle"></i>Aktiv
                                </div>
                            ) : (
                                <div className="isPassive">
                                    <i className="fa-solid fa-circle"></i>Inaktiv
                                </div>
                            )}

                            <div className="date">
                                <span>Skapad: {new Date(item.created).toLocaleDateString()}</span>
                            </div>
                            <div className="date">
                                <span>Giltlig: {new Date(item.lastShowDate).toLocaleDateString()}</span>
                            </div>
                            <div>
                            <div>
                                
                            </div>
                            <div className='confirm'>
                            <button className="btn" onClick={(event) => handleUpdate(item.id, event)}>Update</button>
                            <button className="btn btn-delete" onClick={(event) => handleDeleteConfirm(event, item.id)}>Delete</button>
                                {confirmDeleteId === item.id && (
                                    <>
                                        <button className='btn btn-confirm'>Bekräfta :</button>
                                        <button className='btn' onClick={(event) => handleDelete(item.id, event)}>Ja</button>
                                        <button className='btn' onClick={(event) => handleCancelDelete(event)}>Nej</button>
                                    </>
                            )}
                            </div>
                            
                         
                            
                           
                          
                            
                           
                        </div>

                        </div>
                    );
                })
            ) : (
                !error && data.length === 0 ? <p>Loading...</p> : null
            )}
        </div>
    );
};

export default NewsList;
